"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMediaQuery = void 0;
// TODO: Переделать, т.к. первый и третий ифы перепутаны местами по смыслу
var getMediaQuery = function (from, to) {
    if (from && !to) {
        return "@media (max-width: ".concat(from, "px)");
    }
    if (from && to) {
        return "@media (min-width: ".concat(from, "px) and (max-width: ").concat(to, "px)");
    }
    if (!from && to) {
        return "@media (min-width: ".concat(to, "px)");
    }
    return '';
};
exports.getMediaQuery = getMediaQuery;
//# sourceMappingURL=getMediaQuery.js.map